import React from "react";
import CustomCheckBox from "../CustomCheckBox/CustomCheckBox";

function ReviewChecklist({ styles, refProp, data, selectedValues, handleCheckboxChange }) {
  return (
    <div style={{ width: "80%", margin: "auto" }} ref={refProp}>
      <div className={styles.fields} style={{ fontWeight: "900" }}>
        <p className={styles.fieldName}></p>
        <CustomCheckBox
          data={data}
          name="review"
          onCheckChange={handleCheckboxChange}
          selectedValues={selectedValues}
        />
      </div>
    </div>
  );
}

export default ReviewChecklist;


